module.exports = __webpack_public_path__ + "media/10.65e66cfa.mp3";